import { CORES_OPERACIONAIS } from '@/data/cadastros';

/** Nome de cada cor da paleta, para quem não enxerga a amostra. */
const NOMES: Record<string, string> = {
    '#2986FF': 'Azul',
    '#22C55E': 'Verde',
    '#B87503': 'Âmbar',
    '#8B5CF6': 'Violeta',
    '#0EA5A4': 'Turquesa',
    '#EC7C1B': 'Laranja',
    '#7E8192': 'Cinza',
    '#E5484D': 'Vermelho',
};

export interface SeletorDeCorProps {
    valor: string;
    onChange: (cor: string) => void;
    /** Nome do grupo para leitores de tela. */
    rotulo: string;
}

/**
 * A paleta de filas e etiquetas.
 *
 * Grupo de rádio de verdade, e não uma fileira de botões soltos: a amostra
 * escolhida precisa ser anunciada como escolhida.
 */
export function SeletorDeCor({ valor, onChange, rotulo }: SeletorDeCorProps) {
    return (
        <div role="radiogroup" aria-label={rotulo} style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {CORES_OPERACIONAIS.map((cor) => {
                const escolhida = valor.toUpperCase() === cor;
                return (
                    <button
                        key={cor} type="button" role="radio" aria-checked={escolhida}
                        aria-label={NOMES[cor] ?? cor}
                        onClick={() => onChange(cor)}
                        style={{
                            width: 30, height: 30, borderRadius: 'var(--radius-xs)', background: cor, cursor: 'pointer',
                            border: escolhida ? '2px solid var(--text-primary)' : '1px solid var(--border-strong)',
                            boxShadow: escolhida ? '0 0 0 2px var(--surface) inset' : 'none',
                        }}
                    />
                );
            })}
        </div>
    );
}
